import { render, staticRenderFns } from "./collapse-toggle.vue?vue&type=template&id=88e217ec&"
import script from "./collapse-toggle.vue?vue&type=script&lang=js&"
export * from "./collapse-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports